import SafetyStatisticsCard from "../../components/Safety/SafetyStatisticsCard/SafetyStatisticsCard";

const SafetyHomePage = () => {
  return <SafetyStatisticsCard />;
};

export default SafetyHomePage;

